var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-4-item"},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":this.iconUrl}})]),_c('div',{staticClass:"caption"},[_c('p',{staticClass:"caption-main"},[_vm._v(_vm._s(this.title))]),_c('p',{staticClass:"caption-content"},[_vm._v(_vm._s(this.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }